import { defineMessages } from "@/i18n";
import en from "./en";

export const framesConnectionMessages = defineMessages("frames-connection", en);
